'use client';

import type { ChoiceType } from '~/model/ChoiceType';
import classNames from 'classnames';
import { useTranslations } from 'next-intl';
import { roundToNDecimal } from '~/utils/utils';

export const ChoicesJarResult = ({
  resultData,
  resultId,
  answerChoices,
}: ChoicesJarResultPropsType) => {
  const t = useTranslations('SURVEY.RESULTS');
  const columns = resultData?.answers_repartition;
  const numberColumns = columns?.length;
  const roundAverage = roundToNDecimal(resultData?.average);

  return (
    <div
      data-testid="columns-result"
      className={classNames(
        'columns-result',
        `columns-result--col-${numberColumns}`,
      )}
    >
      {columns?.length > 0 && (
        <>
          <div className="result__banner">
            {t.rich('AVERAGE', {
              roundAverage,
            })}
          </div>
          <div data-testid="columns" className="columns-result__scrollable">
            <div className="columns-result__container">
              {columns.map((col, i) => {
                return (
                  <div
                    className="columns-result__column"
                    data-testid="column"
                    key={i}
                  >
                    <div className="columns-result__percentage">
                      {Math.round(col.percentage)}
                      %
                    </div>
                    <div className="columns-result__track">
                      <span
                        className="columns-result__bar"
                        style={{ height: `${col.percentage}%` }}
                      />
                    </div>
                    <div
                      className="columns-result__label"
                      data-testid="column-label"
                    >
                      {col.step_value}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="columns-result__caption">
            {columns.map((c, index) => {
              const choice_title
                = answerChoices?.length > 0
                  && answerChoices.find(q => q['@id'] === c['@id']).title;
              return (
                <span
                  key={`caption-${resultId}-${index}`}
                  className="columns-result__caption-item"
                >
                  {c.step_value}
                  {' '}
                  -
                  {choice_title}
                </span>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};

interface ChoicesJarResultPropsType {
  resultData: Data;
  resultId: number;
  answerChoices: ChoiceType[];
}

interface Data {
  answers_repartition: AnswersRepartitionType[];
  average: number;
}

interface AnswersRepartitionType {
  step_value: number;
  count: number;
  percentage: number;
  choice_title: string;
  '@id': string;
}
